import { createContext } from 'react';
import type { IAppPayloadContext } from './types';

export * from './types';

const AppPayloadContext = createContext<IAppPayloadContext>(
  null as unknown as IAppPayloadContext
);
export default AppPayloadContext;
